/* Dansk katalog for locale-bank-misc-no.js (del 2 av 3).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'km.privateDrivingHelp': 'Privat brug er dokumenteret i kørebogen, men giver ikke fradrag.',
  'km.filterType': 'Type',
  'km.tryOtherSearch': 'Prøv en anden søgning, eller nulstil filteret.',
  'km.distance': 'Distance',
  'km.stops': 'Stop',
  'km.returnYes': 'Ja ({km} km hver vej)',
  'km.returnNo': 'Nej',
  'km.status': 'Status',
  'km.statusLogged': 'Logget',
  'km.statusPosted': 'Bogført',
  'km.route': 'Rute',
  'km.amount': 'Beløb',
  'km.deleteTripBody': 'Er du sikker på, at du vil slette denne køretur{route}? Handlingen kan ikke fortrydes.',
  'km.speedUnit': 'km/t',
  'km.gps.unavailable': 'GPS er ikke tilgængelig i denne browser.',
  'km.gps.denied': 'GPS-adgang blev afvist eller kunne ikke startes.',
  'km.gps.active': 'GPS aktiv',
  'km.gps.inactive': 'GPS er ikke aktiv',
  'km.gps.stop': 'Stop tur',
  'km.gps.start': 'Start tur',
  'km.gps.done': 'Tur fuldført',
  'km.gps.tracking': 'Sporer din position.',
  'km.gps.doneHint': '{km} km registreret. Brug distancen i formularen nedenfor.',
  'km.gps.startHint': 'Start turen for at aktivere GPS-sporing.',
  'km.toast.editTrip': 'Rediger køretur - ret og gem igen',
  'km.toast.openedNotFound': 'Åbnede kørebogen. Kunne ikke finde præcis den køretur, der skulle redigeres automatisk.',
  'km.toast.fillFromTo': 'Udfyld mindst fra- og til-adresse først.',
  'km.toast.calcUnavailable': 'Automatisk km-beregning er ikke tilgængelig endnu.',
  'km.toast.distanceFailed': 'Kunne ikke beregne afstand.',
  'km.toast.kmCalculated': 'Kilometer beregnet automatisk',
  'km.toast.calcFailed': 'Kunne ikke beregne kilometer automatisk.',
  'km.toast.fillPrivate': 'Udfyld dato, fra, til og kilometer, før du gemmer privat kørsel.',
  'km.toast.fillBusiness': 'Udfyld dato, fra, til, formål og kilometer, før du gemmer.',
  'km.toast.updated': 'Køreturen er opdateret',
  'km.toast.saved': 'Køreturen er gemt',
  'km.toast.deleted': 'Køretur slettet',
  'bank.filter.all': 'Alle',
  'bank.filter.processing': 'Til behandling',
  'bank.filter.suggestion': 'Forslag klar',
  'bank.filter.control': 'Kræver kontrol',
  'bank.filter.missing': 'Mangler bilag',
  'bank.filter.deviation': 'Mulig afvigelse',
  'bank.filter.done': 'Færdig',
  'bank.typeGroup.sales': 'Salg',
  'bank.typeGroup.purchase': 'Køb',
  'bank.typeGroup.other': 'Andet',
  'bank.typeGroup.tax': 'Skat og afgifter',
  'bank.typeGroup.loan': 'Lån og gæld',
  'bank.type.invoicePayment': 'Fakturabetaling',
  'bank.type.otherSales': 'Andet salg',
  'bank.type.payOpenSupplier': 'Leverandørfaktura: betal åben',
  'bank.type.newSupplier': 'Leverandørfaktura: registrér ny',
  'bank.type.purchase': 'Almindeligt køb',
  'bank.type.free': 'Fri postering',
  'bank.type.fee': 'Gebyr',
  'bank.type.rounding': 'Øredifference / øreafrunding',
  'bank.type.owner': 'Privat hævning / indskud',
  'bank.type.vat': 'Momsbetaling',
  'bank.type.payroll': 'Forskudstræk / AGA',
  'bank.type.tax': 'Skattebetaling',
  'bank.type.loan': 'Lån / gæld',
  'bank.agaPart.withholding': 'Forskudstræk mod 2600',
  'bank.agaPart.employer': 'Arbejdsgiverafgift mod 2770',
  'bank.agaPart.both': 'Begge samlet, fordelt på 2600 og 2770',
  'bank.vat.none': 'Ingen moms',
  'bank.vat.input': '{{code}} - Indgående moms {{rate}} %',
  'bank.accountFallback': 'Konto {{code}}',
  'bank.countsAsZero': '{{note}} · tæller som 0,00 kr i afstemningen',
  'bank.csv.date': 'Dato',
  'bank.csv.description': 'Beskrivelse',
  'bank.csv.note': 'Note',
  'bank.csv.amount': 'Beløb',
  'bank.csv.balance': 'Saldo',
  'bank.posted.amount': 'Bogført {{amount}}',
  'bank.posted': 'Bogført',
  'bank.posted.vatAmount': 'Moms {{amount}} ({{rate}} %)',
  'bank.posted.vatRate': 'Moms {{rate}} %',
  'bank.err.pickSupplierInvoice': 'Vælg den leverandørfaktura, betalingen vedrører.',
  'bank.err.supplierPaymentMustBeOutgoing': 'Betaling af leverandørfaktura skal være en udbetaling fra banken.',
  'bank.err.supplierPaymentUnavailable': 'Betaling af leverandørfaktura fra bank er ikke tilgængelig endnu.',
  'bank.deviation.intro': 'Disse poster er bogført mod bankkontoen, men Plumme kan ikke finde en sikker banklinje, der forklarer dem.',
  'bank.deviation.none': 'Ingen mulige afvigelser i denne periode.',
  'bank.detail.date': 'Dato',
  'bank.detail.amount': 'Beløb',
  'bank.detail.status': 'Status',
  'bank.detail.postId': 'Post-ID',
  'bank.detail.type': 'Type',
  'bank.detail.period': 'Periode',
  'bank.detail.noReceipt': 'Der er ikke tilknyttet noget bilag til posteringen',
  'bank.detail.receiptPreviewable': 'Bilaget kan forhåndsvises direkte her.',
  'bank.detail.noPreview': 'Der er intet bilag at forhåndsvise.',
  'bank.toast.postingCorrected': 'Den bogførte postering er korrigeret',
  'bank.toast.postingVoided': 'Posteringen er annulleret. Et eventuelt bilag ligger igen i indbakken.',
  'bank.transition.review': 'Kontrollér overgangen fra importeret regnskab, før dette kontoudtog bogføres.',
  'bank.transition.fixOpening': '{{message}} Ret indgående saldo, før du bogfører.',
  'bank.toast.voucherLinkedName': 'Bilag tilknyttet: {{name}}',
  'bank.toast.noVoucherSuggestions': 'SuperPlumma har ingen bilagsforslag at tilknytte.',
  'bank.toast.oneVoucherLinked': 'Ét bilag er tilknyttet',
  'bank.toast.nVouchersLinked': '{{count}} bilag er tilknyttet',
  'bank.toast.linkSuggestedFailed': 'Kunne ikke tilknytte de foreslåede bilag.',
  'bank.toast.linkedToPosted': 'Banklinjen er tilknyttet den allerede bogførte post',
  'bank.toast.linkToPostedFailed': 'Kunne ikke tilknytte banklinjen til den bogførte post.',
  'bank.toast.saveCustomerFirst': 'Gem kunden, før linjen godkendes.',
  'bank.toast.saveSupplierFirst': 'Gem eller vælg leverandøren, før linjen godkendes.',
  'bank.toast.reviewSuggestionFirst': 'Kontrollér forslaget i banklinjen, før du godkender.',
  'bank.toast.invoicePaymentDone': 'Fakturabetalingen er bogført, og banklinjen er færdig',
  'bank.toast.supplierPaymentDone': 'Leverandørfakturaen er betalt, og banklinjen er færdig',
  'bank.toast.enterSupplierName': 'Indtast leverandørnavn, før fakturaen godkendes.',
  'bank.toast.enterInvoiceNumber': 'Indtast fakturanummer, før fakturaen godkendes.',
  'bank.toast.checkCostAccount': 'Kontrollér omkostningskontoen, før fakturaen godkendes.',
  'bank.toast.supplierInvoiceDone': 'Leverandørfakturaen er bogført, og banklinjen er færdig',
  'bank.toast.suggestionDone': 'Forslaget er bogført, og banklinjen er færdig',
  'bank.toast.alreadyDone': 'Banklinjen er allerede bogført og færdig',
  'bank.toast.suggestionNotApproved': 'Forslaget kunne ikke godkendes.',
  'bank.toast.suggestionNeedsReview': 'Forslaget skal kontrolleres før godkendelse.',
  'bank.approve': 'Godkend',
  'bank.toast.pickUnprocessed': 'Vælg mindst én ubehandlet banklinje.',
  'bank.toast.approveLineFailed': 'Kunne ikke godkende banklinjen.',
  'bank.toast.nLinesApproved': '{{count}} linjer godkendt',
  'bank.toast.lineAdded': 'Banklinje tilføjet',
  'bank.toast.lineLinkUnavailable': 'Tilknytning af banklinje er ikke tilgængelig endnu.',
  'bank.toast.linkedToExistingPosted': 'Banklinjen er tilknyttet en eksisterende bogført post',
  'bank.controlPosting.title': 'Bogført bankpost',
  'bank.controlPosting.sub': 'Mulig afvigelse: bogført på bankkontoen, men ikke fundet i kontoudtoget.',
  'bank.toast.openedAsDeviation': 'Banklinjen er åbnet som afvigelse',
  'bank.toast.investmentMatchReopened': 'Banktilknytningen til investeringen er frigivet',
  'bank.toast.balanceCorrectionUnavailable': 'Saldokorrektion er ikke tilgængelig endnu.',
  'bank.toast.openingMustBeNumber': 'Indgående saldo skal være et tal.',
  'bank.toast.openingUpdated': 'Indgående saldo opdateret',
  'bank.toast.openingFromImport': 'Indgående saldo sat fra importovergangen',
  'bank.toast.closingMustBeNumber': 'Udgående saldo skal være et tal.',
  'bank.toast.closingUpdated': 'Udgående saldo opdateret',
  'bank.toast.roundingMustBeNumber': 'Øredifference skal være et tal.',
  'bank.toast.roundingCorrected': 'Øredifference korrigeret',
  'bank.mark.posted': 'Bogført',
  'bank.mark.alreadyPosted': 'Allerede bogført',
  'bank.mark.approved': 'Godkendt',
  'bank.mark.needsReview': 'Kræver kontrol',
  'bank.mark.deviation': 'Mulig afvigelse',
  'bank.mark.suggestion': 'Forslag klar',
  'bank.mark.private': 'Privat',
  'bank.mark.removed': 'Fjernet',
  'bank.mark.new': 'Ikke behandlet',
  'bank.toast.analysisUnavailable': 'SuperPlumma-analyse er ikke tilgængelig endnu.',
  'bank.toast.foundSuggestions': 'SuperPlumma fandt {{count}} forslag til kontrol',
  'bank.toast.noSafeSuggestions': 'SuperPlumma fandt ingen sikre forslag',
  'bank.toast.analysisFailed': 'SuperPlumma kunne ikke analysere banklinjerne.',
  'bank.toast.alreadyArchived': 'Kontoudtoget er allerede afstemt og arkiveret.',
  'bank.toast.reconciledArchived': 'Kontoudtoget er afstemt og arkiveret.',
  'bank.toast.reopenFailed': 'Kunne ikke genåbne afstemningen.',
  'bank.matchMultiple': 'Match flere',
  'bank.transition.title': 'Kontrollér overgangen fra importeret regnskab',
  'bank.transition.changeAnchor': 'Ret »Afstemt til og med« og startsaldo i Indstillinger, hvis importankeret blev sat forkert.',
  'bank.previousNotReconciled': 'Tidligere periode er ikke afstemt',
  'bank.correctViaPencil': 'Korrigér via blyantikonet',
  'bank.correctReadBalance': 'Korrigér aflæst saldo',
  'bank.analysis.alreadyDone': 'Kontoudtoget er allerede analyseret. Ny analyse er spærret for at undgå unødvendigt tokenforbrug.',
  'bank.analysis.autoRunning': 'SuperPlumma analyserer kontoudtoget automatisk.',
  'bank.analysis.analyzedShort': 'Analyseret af SuperPlumma',
  'bank.analysis.analyzingShort': 'SuperPlumma analyserer',
  'bank.archiveBlocked.chronological': 'Afstem {{name}} først. Afstemning skal ske kronologisk, fordi indgående saldo hentes fra det forrige kontoudtog.',
  'bank.archiveBlocked.deviation': 'Saldoafvigelsen skal være 0,00 kr, før kontoudtoget kan arkiveres.',
  'bank.archiveBlocked.lines': 'Alle banklinjer skal behandles, før kontoudtoget kan arkiveres.',
  'bank.reviewAndApprove': 'Kontrollér og godkend',
  'bank.voucherN': 'Bilag {{n}}',
  'bank.voucherLinked': 'Bilag tilknyttet',
  'bank.showVoucher': 'Vis bilag',
  'bank.voucherSuggested': 'Bilag foreslået',
  'bank.voucherMissingBadge': 'Bilag mangler',
  'bank.toast.linkRemoved': 'Tilknytningen er fjernet. Bilaget ligger i indbakken.',
  'bank.sendVouchersBack': 'Send bilagene tilbage til indbakken',
  'bank.toast.vouchersSentBack': 'Bilagene er sendt tilbage til indbakken',
  'bank.analysisHint.tap': 'Lad SuperPlumma analysere linjerne og foreslå bogføring, eller tryk på et bilag og derefter på banklinjen for at koble.',
  'bank.analysisHint.drag': 'Lad SuperPlumma analysere linjerne og foreslå bogføring, eller træk et bilag direkte over på banklinjen for at koble.',
  'bank.showInbox': 'Vis indbakke',
  'bank.toast.lineDone': 'Banklinjen er bogført og færdig',
  'bank.toast.noInboxVouchers': 'Ingen bilag i indbakken at koble.',
  'bank.toast.balanceCorrected': 'Saldoen er rettet',
  'bank.toast.misreadRemoved': 'Den fejlaflæste linje er taget ud af afstemningen',
  'bank.toast.readingCorrected': 'Aflæsningen er rettet',
  'bank.toast.postedFixed': 'Den bogførte post er rettet',
  'bank.toast.lineRemoved': 'Banklinjen er fjernet fra afstemningen',
  'bank.vatTerm.jun': 'Moms {{year}} - 10. juni',
  'bank.vatTerm.apr': 'Moms {{year}} - 10. april',
  'bank.vatTerm.feb': 'Moms {{year}} - 10. februar',
  'bank.vatTerm.aug': 'Moms {{year}} - 31. august',
  'bank.vatTerm.oct': 'Moms {{year}} - 10. oktober',
  'bank.vatTerm.dec': 'Moms {{year}} - 10. december',
  'bank.agaTerm': 'Lønskat/AGA {{n}}. termin {{year}}',
  'bank.ownerAccountFallback': 'Privat-/ejerkonto',
  'bank.periodHint': 'Bankudskriften gælder {{from}} - {{to}}.',
  'bank.voucher': 'Bilag',
  'bank.ownerType.withdrawal': 'Privat hævning',
  'bank.ownerType.deposit': 'Privat indskud',
  'bank.ownerType.both': 'Privat hævning / indskud',
  'bank.ownerType.owner': 'Ejer / mellemregning',
  'bank.vat86.prefix': 'Leverandørbeløbet',
  'bank.vat86.suffix': 'er grundlaget. Kode 86 beregner både udgående og indgående moms med 25 % uden at reducere bankbeløbet.',
  'bank.postedWithoutVat': 'bogføres uden moms.',
  'bank.withVatRate': 'med {{rate}} % moms.',
  'bank.amountHelp.locked': 'Beløbet er hentet fra bankudskriften og kan ikke ændres.',
  'bank.amountHelp.unlocked': 'Posteringen er ikke koblet til en banklinje, så beløbet kan rettes her. Ændringen gemmes i revisionssporet.',
  'bank.amountHelp.mustMatch': 'Beløbet skal stemme med den faktiske banktransaktion.',
  'bank.err.enterAmount': 'Angiv bankbeløb, før du gemmer linjen.',
  'bank.err.dateWithinStatement': 'Datoen skal ligge inden for bankudskriften: {{from}} - {{to}}.',
  'bank.err.pickTwoAccountsFree': 'Vælg to forskellige konti, før du gemmer fri postering.',
  'bank.err.enterSupplierName': 'Angiv leverandørnavn, før du gemmer leverandørfakturaen.',
  'bank.err.enterInvoiceNumber': 'Angiv fakturanummer, før du bogfører leverandørfakturaen.',
  'bank.err.invoicePaymentIncoming': 'En fakturabetaling skal være en indbetaling til banken.',
  'bank.err.pickInvoice': 'Vælg faktura, før du gemmer fakturabetalingen.',
  'bank.err.pickOwnerAccount': 'Vælg privat-/ejerkonto, før du godkender posteringen.',
  'bank.err.pickLoanAccount': 'Vælg låne-/gældskonto, eller brug fri postering.',
  'bank.err.loanSplitSum': 'Afdrag, renter og gebyr skal summere til bankbeløbet.',
  'bank.err.supplierPaymentOutgoing': 'Betaling af leverandørfaktura skal være en udbetaling fra banken.',
  'bank.err.pickSupplierInvoiceBeforeSave': 'Vælg leverandørfaktura, før du gemmer betalingen.',
  'bank.err.correctionReason': 'Skriv kort, hvorfor posteringen rettes.',
  'bank.err.noReceiptReason': 'Angiv en kort begrundelse for, hvorfor et selvstændigt bilag ikke er nødvendigt.',
  'bank.err.linkVoucherOrWaive': 'Kobl et bilag, eller markér, at separat dokumentation ikke findes eller ikke er nødvendig.',
  'bank.err.uploadUnavailable': 'Upload af bilag er ikke tilgængelig endnu.',
  'bank.err.analysisFailedAfterUpload': 'Bilaget blev uploadet, men analysen mislykkedes.',
  'bank.toast.uploadedAndLinked': 'Bilaget er uploadet og koblet til banklinjen.',
  'bank.toast.linkOnSaveCorrection': 'Bilaget kobles, når du gemmer rettelsen.',
  'bank.toast.linkOnSaveLine': 'Bilaget kobles, når du gemmer banklinjen.',
  'bank.err.uploadFailed': 'Bilaget kunne ikke uploades.',
  'bank.modal.correctPosting': 'Ret postering',
  'bank.modal.editLine': 'Redigér banklinje',
  'bank.modal.saveCorrection': 'Gem rettelse',
  'bank.modal.approveAndClose': 'Godkend og luk',
  'bank.modal.fieldsLocked': 'Bankbeløb, dato, type og bankkobling er låst. Konto, moms og intern beskrivelse kan rettes med revisionsspor.',
  'bank.modal.correctionUnlocked': 'Posteringen er ikke koblet til en banklinje i bankudskriften. Dato, beløb, konto, moms, bilag og intern beskrivelse kan rettes med revisionsspor. Er selve posteringstypen forkert, skal posteringen annulleres og bogføres på ny.',
  'bank.modal.manualLineHelp': 'Brug kun dette, når en faktisk banktransaktion mangler i udskriften, for eksempel ved importfejl eller en banklinje, der skal bogføres manuelt før afstemning.',
  'bank.help.sales': 'Salg bruger standardsalgskonto og momsopsætning. Senere kobles dette til faktura/KID, når det findes.',
  'bank.help.ownerSole': '{{label}} bogføres mellem bank og valgt privatkonto uden indtægt, omkostning eller moms.',
  'bank.help.ownerUnknownEntity': 'Virksomhedsform er ikke angivet i indstillingerne, så Plumme foreslår ingen konto her. Vælg selv modkonto, eller angiv virksomhedsform for at få forslag.',
  'bank.help.ownerIntercompany': 'Dette er en ejer-/mellemregningspostering, ikke en privat ENK-postering. Vælg en dokumenteret modkonto; lån, udbytte og kapitalindskud skal behandles i det rette faglige flow.',
  'bank.label.privateAccount': 'Privatkonto',
  'bank.label.ownerAccount': 'Ejer-/mellemregningskonto',
  'bank.help.shareholderTitle': 'Hævning fra selskabet.',
  'bank.help.shareholderBody': 'Mellemregningen foreslås, fordi den samler ejerforholdet på én saldo. Er dette ikke tilbagebetaling af det, selskabet skylder dig, bliver det et lån til aktionær: asl. §8-7 stiller krav til dækning og sikkerhed, og sktl. §10-11 fjerde stykke beskatter det som udbytte hos dig. Udbytte og løn skal bogføres i deres egne flows.',
  'bank.help.invoicePayment': 'Brug denne, når bankindbetalingen gælder en eksisterende salgsfaktura. Bogføringen sker mod kundetilgodehavendet og den valgte bankkonto.',
  'bank.settlement.linked': 'Afregningsrapport koblet:',
  'bank.settlement.detail': 'fakturaen betales med {{gross}}, gebyr {{fee}} og netto bankindbetaling {{payout}}.',
  'bank.help.noInvoiceMatch': 'Ret beløbet, eller brug Andet salg, hvis indbetalingen ikke gælder en faktura.',
  'bank.help.supplierPayment': 'Brug denne, når bankudbetalingen gælder en leverandørfaktura, der allerede er registreret. Betalingen bogføres mod leverandørgælden og den valgte bankkonto.',
  'bank.pickOpenSupplierInvoice': 'Vælg åben leverandørfaktura',
  'bank.supplierInvoiceRemaining': '{{number}} · {{supplier}} · resterer {{amount}}',
  'bank.overpayment': 'Overbetaling {{amount}}.',
  'bank.overpaymentHelp': 'Hele bankbeløbet registreres på leverandørfakturaen, og det overskydende står som tilgodehavende hos leverandøren.',
  'bank.noSupplierInvoiceFits': 'Ingen åbne leverandørfakturaer passer til beløbet.',
  'bank.noSupplierInvoiceFitsHelp': 'Ved overbetaling skal restbeløbet matches mod fakturaen og det overskydende føres separat.',
  'bank.help.taxPayment': 'Brug kun denne til betalinger til Skatteetaten, der ikke er en konkret momstermin eller skattetræk/AGA.',
  'bank.selectedFeeAccount': 'valgt gebyrkonto',
  'bank.selectedRoundingAccount': 'valgt afrundingskonto',
  'bank.help.roundingWarning': 'Øredifferencer skal normalt være mindre end 1 kr. Større afvigelser skal forklares ved at kontrollere saldo og banklinjer.',
  'bank.help.free': 'Fri postering bruges til overførsler, gæld, mellemregning, korrektioner eller andre bankhændelser, der ikke er almindeligt køb, salg eller fakturabetaling.',
  'bank.help.newSupplierInvoice': 'Brug denne, når leverandørfakturaen ikke er registreret endnu. Banklinjen gemmes med leverandørfakturadetaljer, så den kan kobles videre.',
  'bank.correction.requiredHint': 'Påkrævet. Gemmes i revisionssporet.',
  'bank.correction.reasonPh': 'Beskriv kort, hvorfor posteringen korrigeres',
  'bank.noSeparateDoc.bank': 'Kontoudtoget er dokumentation – et selvstændigt bilag er ikke nødvendigt',
  'bank.noSeparateDoc.other': 'Der findes ingen separat dokumentation, eller den er ikke nødvendig',
  'bank.shortReasonPh': 'Kort begrundelse',
  'bank.toast.pickFromInbox': 'Vælg et bilag fra Indbakke, ikke Dokumentation.',
  'bank.toast.linkedOnCorrection': 'Bilaget kobles, når du gemmer korrektionen.',
  'bank.toast.linkedToLine': 'Bilaget er koblet til banklinjen.',
  'bank.priv.filterAll': 'Alle',
  'bank.priv.filterOperating': 'Drift',
  'bank.priv.filterNew': 'Ikke behandlet',
  'bank.priv.filterIgnore': 'Ignorér',
  'bank.priv.statusIgnored': 'Ignoreret',
  'bank.priv.noSafeMatches': 'Ingen sikre bilagsmatch at koble endnu',
  'bank.priv.linkedN': 'Koblede {{count}} bilag til private banklinjer',
  'bank.priv.pickOneLine': 'Vælg mindst én banklinje.',
  'bank.priv.ignoredN': '{{count}} linjer ignoreret',
  'bank.priv.movedN': '{{count}} linjer flyttet til driften',
  'bank.priv.intro': 'Privat bank bruges som et oprydningsværktøj: markér firmarelaterede linjer som Drift, og ignorér private eller irrelevante linjer. Det, der markeres til driften, bogføres på driftskontoen.',
  'bank.priv.movedToOperating': 'Flyttet til driften',
  'bank.priv.noteTap': 'Lad SuperPlumma koble dem automatisk, eller tryk på et bilag og derefter på banklinjen.',
  'bank.priv.noteDrag': 'Lad SuperPlumma koble dem automatisk, eller træk et bilag direkte over på banklinjen.',
  'bank.toast.lineUpdated': 'Banklinje opdateret',
  'bank.err.excelParserMissing': 'Excel-parseren er ikke indlæst.',
  'bank.err.pdfParserMissing': 'PDF-parseren er ikke indlæst.',
  'bank.toast.addBankAccountFirst': 'Tilføj først en bankkonto i indstillinger',
  'bank.err.archiveUnavailable': 'Arkivering af kontoudtog er ikke tilgængelig endnu.',
  'bank.toast.privateReviewArchived': 'Privatgennemgangen er gennemført og arkiveret',
  'bank.err.archiveFailed': 'Kunne ikke arkivere kontoudtoget',
  'bank.err.reopenUnavailable': 'Genåbning af kontoudtog er ikke tilgængelig endnu.',
  'bank.toast.statementReopened': 'Kontoudtoget er åbnet igen',
  'bank.err.reopenStatementFailed': 'Kunne ikke åbne kontoudtoget igen',
  'bank.account.private': 'Privatkonto',
  'bank.account.operating': 'Driftskonto',
  'bank.group.operating': 'Driftskonti',
  'bank.group.private': 'Privatkonti',
  'bank.group.doneReviews': 'Færdiggennemgåede private kontoudtog',
  'bank.group.doneReconciled': 'Færdigafstemte kontoudtog',
  'bank.unknownPeriod': 'Ukendt periode',
  'bank.handledOf': '{{handled}} af {{lines}} håndteret',
  'bank.page.privateTitle': 'Privat bank',
  'bank.page.title': 'Bankafstemning',
  'bank.page.privateSubtitle': 'Ryd op i privatkontoen - markér firmarelaterede linjer som drift, og ignorér resten.',
  'bank.page.subtitle': 'Indlæs XLSX, CSV, PDF eller et skærmbillede fra banken, markér firmalinjer som drift, og arkivér færdige kontoudtog.',
  'bank.tab.operating': 'Drift',
  'bank.tab.private': 'Privat',
  'bank.tab.archive': 'Arkiv',
  'bank.page.privateUploadHelp': 'Upload kun det private kontoudtog her, når du vil finde firmarelaterede udlæg. Det gemmes på den valgte virksomhed, men uden bankkonto fra Indstillinger.',
  'bank.noAccountRegistered': 'Ingen bankkonto registreret',
  'bank.stmt.reviewed': 'Gennemgået',
  'bank.stmt.toReview': 'Til gennemgang',
  'bank.stmt.toReconcile': 'Til afstemning',
  'bank.dropzone.uploadMore': 'Upload flere kontoudtog',
  'bank.dropzone.none': 'Ingen kontoudtog endnu',
  'bank.dropzone.help': 'Træk en CSV-, PDF-, XLSX- eller billedfil fra banken ind, klik for at vælge, eller indsæt et skærmbillede med Ctrl+V. Vi matcher linjerne med dine bilag automatisk.',
  'bank.connectHelp2': 'Hent transaktioner automatisk, og lad SuperPlumma bogføre og afstemme regnskabet løbende - slip for manuel upload og bogføring.',
  'bank.toast.openBankingInfo': 'Sikker forbindelse til banken via Open Banking',
  'bank.guided.step1.title': 'Kontrollér kontoudtoget',
  'bank.guided.step1.sub': 'Tjek periode og saldo',
  'bank.guided.step2.title': 'Godkend forslag',
  'bank.guided.step2.sub': 'Kontrollér det, Plumme har fundet',
  'bank.guided.step3.title': 'Behandl resten',
  'bank.guided.step3.sub': 'Vælg, hvad betalingerne vedrører',
  'bank.guided.step4.title': 'Kobl bilag',
  'bank.guided.step4.sub': 'Dokumentér købene',
  'bank.guided.step5.title': 'Afslut',
  'bank.guided.step5.sub': 'Kontrollér og arkivér',
  'bank.guided.stepOf': 'Trin {{step}} af {{total}}',
  'bank.guided.action.matched': 'Matchet mod allerede bogført',
  'bank.guided.action.fee': 'Bankgebyr',
  'bank.guided.action.invoice': 'Fakturabetaling',
  'bank.guided.action.purchase': 'Kendt køb',
  'bank.guided.action.sale': 'Registrér salg',
  'bank.guided.suggestionFromSuper': 'Forslag fra SuperPlumma',
  'bank.guided.receivables': 'Debitorer',
  'bank.guided.suggestedCostAccount': 'Foreslået omkostningskonto',
  'bank.guided.reason.sameAmount': 'Samme beløb og betalingsreference',
  'bank.guided.reason.textBased': 'Baseret på tekst, beløb og tidligere bogføring',
  'bank.guided.suggestsAction': 'Plumme foreslår: {{action}}',
  'bank.guided.vatLine': '{{account}} · {{vat}} moms · Beløb {{amount}}',
  'bank.guided.voucherSuffix': ' · bilag: {{name}}',
  'bank.guided.out': 'UD',
  'bank.guided.in': 'IND',
  'bank.guided.moneyOut': 'PENGE UD',
  'bank.guided.moneyIn': 'PENGE IND',
  'bank.guided.unprocessedLine': '{{direction}} · Ikke behandlet',
  'bank.guided.bankPeriod': 'Bankperiode',
  'bank.guided.handledLeft': '{{handled}}/{{total}} behandlet · {{left}} tilbage',
  'bank.guided.reopenNote': 'Åbner du afstemningen igen, låses perioden op til kontrol. Bogførte linjer skal korrigeres eller annulleres med revisionsspor, før de kan behandles på ny.',
  'bank.guided.toast.enterClosing': 'Indtast slutsaldoen fra kontoudtoget.',
  'bank.guided.err.checkIndividually': 'Et eller flere forslag skal kontrolleres enkeltvis.',
  'bank.guided.toast.suggestionsDone': '{{count}} forslag er bogført og færdige',
  'bank.guided.err.approveSuggestions': 'Kunne ikke godkende forslagene.',
  'bank.guided.toast.roundingPosted': 'Afrundingsdifferencen på {{amount}} er bogført',
  'bank.guided.err.roundingFailed': 'Kunne ikke bogføre afrundingsdifferencen.',
  'bank.guided.toast.markedNoVoucher': 'Købet er markeret uden bilag',
  'bank.guided.err.saveChoice': 'Kunne ikke gemme valget.',
  'bank.guided.err.voucherNotFound': 'Kunne ikke finde bilaget i indbakken.',
  'bank.guided.err.linkFailed': 'Kunne ikke koble bilaget.',
  'bank.guided.toast.noSafeHits': 'Fandt ingen sikre bilagsmatch at koble.',
  'bank.guided.h.check': 'Stemmer perioden og saldoen?',
  'bank.guided.h.rest': 'Hvad vedrører de resterende betalinger?',
  'bank.guided.p.check': 'Tjek, at dette er det rigtige kontoudtog, og indtast saldoen ved periodens slutning.',
  'bank.guided.p.rest': 'Vælg, hvad hver betaling vedrører. Du behøver ikke at kende kontonumre — Plumme hjælper dig med bogføringen.',
  'bank.guided.openingHint': 'Hentes normalt fra den forrige færdige afstemning.',
  'bank.guided.closingHint': 'Find beløbet på kontoudtoget fra banken.',
  'bank.guided.closingMatches': 'Bankens slutsaldo svarer til det, Plumme har beregnet.',
  'bank.guided.posting': 'Bogfører…',
  'bank.guided.postRounding': 'Bogfør afrundingsdifferencen',
  'bank.guided.smallRounding': 'Lille afrundingsafvigelse på {{amount}}',
  'bank.guided.balanceDeviates': 'Saldoen afviger med {{amount}}.',
  'bank.guided.balanceDeviatesHelp': 'Behandl betalingerne i de næste trin, og kom tilbage, hvis afvigelsen består.',
  'bank.guided.canReturn': 'Du kan altid vende tilbage til dette trin senere.',
  'bank.guided.correctToContinue': 'Korrigér saldiene med blyantikonet for at gå videre.',
  'bank.guided.checkedContinue': 'Kontoudtoget er kontrolleret – fortsæt',
  'bank.guided.superIntro': 'Nogle linjer er matchet mod poster, der allerede er bogført, for andre har SuperPlumma foreslået bogføring. Kontrollér dem, og tryk godkend — intet bogføres, før du godkender.',
  'bank.guided.count.matched': 'matchet mod allerede bogført',
  'bank.guided.count.invoice': 'fakturabetalinger',
  'bank.guided.count.purchase': 'kendte køb',
  'bank.guided.count.fee': 'bankgebyrer',
  'bank.guided.count.receipt': 'bilag fundet automatisk',
  'bank.guided.fixReading': 'Korrigér aflæsning fra PDF/CSV',
  'bank.guided.suggestionsPending': '{{count}} forslag er ikke godkendt endnu. Du kan godkende dem nu eller komme tilbage.',
  'bank.guided.allSuggestionsDone': 'Alle forslag er behandlet.',
});
